<template>
    <Example
        class="example"
        :hasResponse="hasResponse"
        :requestInfo="requestInfo"
    >
        <template #title>
            Вывод средств (withdraw)
        </template>
        <template #settings>
            <div class="example__row">
                <div class="example__col">
                    <ExampleSetting title="Валюта (currency)">
                        <select
                            class="example__select"
                            :class="currencyStatus"
                            v-model="currency"
                        >
                            <option value="">
                                Выберите
                            </option>
                            <option
                                v-for="(currency, key) in currencies"
                                :key="key"
                                :value="currency.currency"
                            >
                                {{ currency.currency }}
                            </option>
                        </select>
                    </ExampleSetting>
                </div>
                <div class="example__col">
                    <ExampleSetting title="Error webhook (errorWebhook)">
                        <AtInput
                            size="small"
                            :status="errorWebhookStatus"
                            v-model="errorWebhook"
                        />
                    </ExampleSetting>
                </div>
                <div class="example__col">
                    <ExampleSetting title="Success webhook (successWebhook)">
                        <AtInput
                            size="small"
                            :status="successWebhookStatus"
                            v-model="successWebhook"
                        />
                    </ExampleSetting>
                </div>
            </div>
            <div class="example__table">
                <p class="example__table-title">
                    Адреса для вывода
                </p>
                <div class="example__table-header example__table-row">
                    <div class="example__table-header-col col">
                        Сумма (amount)
                    </div>
                    <div class="example__table-header-col col">
                        Адрес (address)
                    </div>
                    <div class="example__table-header-col col">
                        Тег (tag)
                    </div>
                    <div class="example__table-header-col col-1" />
                </div>
                <WithdrawAddress
                    v-for="(item, key) in items"
                    :key="key"
                    :data="item"
                    :index="key"
                    @removeAddress="removeAddress"
                />
            </div>
            <div class="example__row">
                <div class="example__col">
                    <AtButton @click="addAddress">
                        Добавить адрес
                    </AtButton>
                </div>
            </div>
            <div class="example__actions">
                <AtButton
                    type="primary"
                    size="large"
                    @click="makeRequest"
                >
                    Сделать запрос
                </AtButton>
                <AtButton
                    v-if="hasResponse"
                    size="large"
                    @click="clear"
                >
                    Очистить
                </AtButton>
            </div>
        </template>
        <template #response>{{ response }}</template>
    </Example>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex';

import { exampleMixin } from "/public/mixins/example";

import Example from './Example';
import ExampleSetting from "./ExampleSetting";
import AtInput from 'at-ui/src/components/input';
import AtButton from "at-ui/src/components/button";
import WithdrawAddress from "./WithdrawAddress";

export default {
    name: 'Withdraw',
    components: {
        Example,
        ExampleSetting,
        AtInput,
        AtButton,
        WithdrawAddress,
    },
    mixins: [exampleMixin],
    data () {
        return {
            currency: null,
            errorWebhook: null,
            successWebhook: null,
            items: [
                {
                    amount: null,
                    address: null,
                    tag: null,
                },
            ],
            response: null,
        };
    },
    computed: {
        ...mapState('app', [
            'currencies',
        ]),
        ...mapGetters('user', [
            'hasTestApiKeys',
        ]),
        hasResponse () {
            return Boolean(this.response);
        },
        currencyStatus () {
            return !this.currency ? 'error' : '';
        },
        errorWebhookStatus () {
            return /*!this.errorWebhook ? 'error' : */'';
        },
        successWebhookStatus () {
            return /*!this.successWebhook ? 'error' : */'';
        },
    },
    methods: {
        ...mapActions('app', [
            'apiRequest',
        ]),
        addAddress () {
            this.items.push({
                amount: null,
                address: null,
                tag: null,
            });
        },
        removeAddress (index) {
            this.items.splice(index, 1);
        },
        makeRequest () {
            const {
                hasTestApiKeys,
                currency,
                items,
                errorWebhook,
                successWebhook,
                apiRequest,
                setRequestInfo,
            } = this;

            if (!hasTestApiKeys) {
                return false;
            }

            apiRequest({
                method: 'make-withdrawal',
                data: {
                    currency,
                    items,
                    errorWebhook,
                    successWebhook,
                },
            })
                .then(resp => {
                    const {
                        data: {
                            response,
                        },
                    } = resp;

                    this.response = response;
                    setRequestInfo(resp);
                })
                .catch(error => {
                    this.response = error.response.data;
                    setRequestInfo(error.response);
                });
        },
        clear () {
            this.currency = null;
            this.amount = null;
            this.address = null;
            this.tag = null;
            this.errorWebhook = null;
            this.successWebhook = null;
            this.response = null;
        },
    },
};

</script>
